import { getEditorBlockConfig } from "@babackapp/editor-blocks-library/blocks";
import useBlockFormApi from "../hooks/useBlockFormApi";
import { Block } from "../types";
import { useBlockIndexSection } from "../hooks/use-block-index-section";
import { useEditorContext } from "./editor";
import { useShop } from "./shop-provider";


export default function EditorBlockPanelRenderer({ block, containerRef }: {
  block: Block,
  containerRef: React.RefObject<HTMLDivElement | null>
}) {
  const { section, index } = useBlockIndexSection(block.id);
  const { currentLocale, theme, variables, defaultLocale, editorMode, localeCodes } =
    useEditorContext();
  const shop = useShop();
  const blockType = block?.type;
  const blockConfig = getEditorBlockConfig(blockType);
  const formAPI = useBlockFormApi(section, index);

  const EmailPanel = blockConfig?.email?.configPanel?.component;

  if (!blockType || !EmailPanel) {
    return (
      <div className="p-2 text-sm text-muted-foreground">
        Aucun paramètre disponible pour ce bloc.
      </div>
    );
  }

  return (
    <EmailPanel
      theme={theme}
      locale={currentLocale}
      defaultLocale={defaultLocale}
      localeCodes={localeCodes}
      formatter={(v: string) => v}
      shop={shop}
      section={section}
      block={block as never}
      index={index}
      formAPI={formAPI}
      variables={variables}
      containerRef={containerRef}
      editorMode={editorMode}
    />
  );
}
